import getCommonLoginRequest from './getCommonLoginRequest';

const isRecaptcha = true;
const getRecaptchaLoginRequest = (recaptchaToken) => {
  const recaptchaLoginRequest = {
    recaptchaResponse: recaptchaToken,
    usrLoginName: window.REACT_APP_GOOGLE_RECAPTCHA_USER_LOGIN_NAME,
    password: window.REACT_APP_GOOGLE_RECAPTCHA_USER_PASSWORD,
    apiKey: window.REACT_APP_API_KEY_CAPTCHA,
    ...getCommonLoginRequest(isRecaptcha),
  };

  return recaptchaLoginRequest;
};

export default getRecaptchaLoginRequest;
